const en = {
  rule: 'Rule and regulations',
  Referral: 'Referral',
  Total_Earnings: 'Total Earnings',
  Top_Referrer: 'Top Referrer',
  share: 'Share',
  Starter_Referrer: 'Starter Referrer',
  refer_desc:
    ' After the new user places and pays for an order, the system will reward the referrer as follows:',
  points: 'Points',
  cash_voucher: 'Cash voucher',
  international: 'International',
  next_day_delivery: 'Next Day Service',
  n_user: '{num1}person(s)',
  your_referral_code: 'Your referral code',
  already_top_referral: 'You have become「Top Referrer」',
  already_top_referral_text: 'The system will reward the referrer as follows',
  zai_add_new_user_n:
    'Invite {num1} new users to upgrade to 「 Top Referrer 」',
  open_lock_five_new_user: 'Unlocked the 5th new user',
  Invitation_record: 'Invitation record',

  // Register page
  register_title: 'Register',
  phone: 'Phone Number',
  phone_placeholder: 'Please enter phone number',
  phone_required: 'Phone number is required',
  phone_length: 'Phone number must not exceed 13 characters',
  password: 'Password',
  password_placeholder: 'Please enter password',
  password_required: 'Password is required',
  verification_code: 'Verification Code',
  verification_code_placeholder: 'Please enter verification code',
  verification_code_required: 'Verification code is required',
  verification_code_format: 'Must be digits, max 6 characters',
  send_code: 'Get Code',
  resend_code: 'Resend',
  privacy_agreement: 'I have read and agree to the Privacy Policy',
  please_check_privacy: 'Please agree to the Privacy Policy',
  download_app: 'Download J&T Malaysia App',
  name: 'Name',
  name_placeholder: 'Please enter name',
  name_length: 'Name must not exceed 50 characters',
  name_invalid_char: 'Name contains invalid characters',
  id_number: 'ID / Passport / SSM',
  id_number_placeholder: 'Please enter ID / Passport / SSM',
  id_number_required: 'ID / Passport / SSM is required',
  id_number_format: 'Must be digits, max 12 characters',
  email: 'Email',
  email_placeholder: 'Please enter email',
  email_required: 'Email is required',
  email_format: 'Invalid email format',
  referral_code: 'Referral Code',
  referral_code_placeholder: 'Referral Code',
  postcode: 'Postcode',
  postcode_placeholder: 'Please enter postcode',
  postcode_format: 'Postcode must be 5 digits',
  postcode_not_found: 'Postcode not found',
  city: 'City',
  city_placeholder: 'City will be auto-filled by postcode',
  city_required: 'City is required, please enter a valid postcode',
  address: 'Address',
  address_placeholder: 'Please enter address',
  address_length: 'Address must not exceed 250 characters',
  address_invalid_char: 'Address contains invalid characters',
  complete_register: 'Complete Registration',
  register_success: 'Registration Successful',
  register_success_desc: 'Congratulations on your successful registration!',
  back_to_home: 'Back to Home',
  account_info: 'Account Information',
  identity_info: 'Identity Information',
  contact_address: 'Contact Address',
  privacy_prefix: 'I have read and agree to J&T Express',
  privacy_terms: 'Terms and Privacy Policy',
  already_have_account: 'Already have an account?',
  download_jt_malaysia_app: 'Log in now',
  area_placeholder: 'Please select / enter city',
  verification_code_error: 'Incorrect verification code',
  register_success_title: 'Congratulations, registration successful!',
  register_success_detail:
    'Your account has been activated. Download the App now to unlock more<br />logistics services & exclusive rewards',
  download_jt_malaysia_app_now: 'Log in now',
  register_download_desc:
    'After downloading the App, log in with your registered phone number<br />to use all services and claim rewards',
  register_footer_text: 'J&T Malaysia · Providing convenient logistics services'
}

export default en
